module.exports = "/images/flag-other.svg?66455120049fa7b234e613d455d55120";